export const language = {
  zh: {
    'Contact Us': '联系我们',
    'Tel No.': '联系电话',
    'Email': '邮箱',
    'Log out': '退出登录',
    'Change Password': '修改密码',
    'Company Management': '公司管理',
    'Check the progress of application': '查看审批进度',
    'Apply to be a Supplier': '申请成为供应商',
    'Supplier Center': '供应商中心',
    'On Lining': '该功能即将上线',
    'Log in': '登录',
    'Create': '注册',
    'Buyer Center': '买家中心',
    'Related Applications': '相关应用',
    'CP Quality Inspection': '正大质检小程序',
    'Return': '返回',
  },
  en: {
    'Contact Us': 'Contact Us',
    'Tel No.': 'Tel No.',
    'Email': 'Email',
    'Log out': 'Log out',
    'Change Password': 'Change Password',
    'Company Management': 'Company Management',
    'Check the progress of application': 'Check the progress of application',
    'Apply to be a Supplier': 'Apply to be a Supplier',
    'Supplier Center': 'Supplier Center',
    'On Lining': 'On Lining',
    'Log in': 'Log in',
    'Create': 'Create',
    'Buyer Center': 'Buyer Center',
    'Related Applications': 'Related Applications',
    'CP Quality Inspection': 'CP Quality Inspection',
    'Return': 'Return'
  }
};
